import { VERIFY_TELEPATHOLOGY_REPORT } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';


const verifyTelePathologyReport = createAsyncThunk('verifyTelePathologyReportApi', async (obj: any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = VERIFY_TELEPATHOLOGY_REPORT
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(obj)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default verifyTelePathologyReport;
